import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Form, Button, Input } from "reactstrap";
import TextField from "../../../common/TextField";
import { toast } from "react-toastify";
import { useMutationRequestQuery } from "../../../../Hooks/useMutationRequestQuery";
 import { useSafeNavigate } from "../../../../Hooks/useSafeNavigate";
import { createTrainingDocService } from "../../../../Services/CRMAdminServices/CRMTrainingDocsService";

export default function AddTrainingDoc() {
  const queryClient = useQueryClient();
  const navigate = useSafeNavigate();
  const [formData, setFormData] = useState<{ documentName: string; file: File | null }>({
    documentName: "",
    file: null,
  });
  const [formErrors, setFormErrors] = useState<any>({});

  const handleValueChange = (name: string, value: any) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev: any) => ({ ...prev, [name]: "" }));
  };

  const { mutate: addDoc, isPending: isAdding } = useMutationRequestQuery(
    "addTrainingDoc",
    createTrainingDocService,
    {
      onSuccess: () => {
        toast.success("Training Doc added successfully.");
        navigate("/CRMTraining");
        queryClient.invalidateQueries({ queryKey: ["getAllTrainingDocs"] });
      },
      onError: () => {
        toast.error("Failed to add training doc.");
      },
    }
  );

  const handleSubmit = (e: any) => {
    e.preventDefault();
    let errors: any = {};
    if (!formData.documentName) errors.documentName = "Document Name is required!";
    if (!formData.file) errors.file = "File is required!";

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    const formDataObj = new FormData();
    formDataObj.append("DocumentName", formData.documentName);
    formDataObj.append("File", formData.file!);

    addDoc(formDataObj);
  };

  return (
    <div className="px-4 py-4">
      <Form>
        <TextField
          label="Document Name:"
          type="text"
          name="documentName"
          value={formData.documentName}
          setValue={handleValueChange}
          placeholder="Enter document name"
          passCol="col-6"
          error={formErrors.documentName}
          errorMessage="Document Name is required!"
        />
 <div className="mb-3" style={{width:"40%"}}>             <label className="form-label fw-bold">Upload File:</label>
          <Input
            type="file"
                accept=".pdf, .doc, .docx, .xls, .xlsx, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={(e) => handleValueChange("file", e.target.files ? e.target.files[0] : null)}
            />
          {formErrors.file && <span className="text-danger">{formErrors.file}</span>}
        </div>
        <div className="d-flex gap-3 mt-3">
          <Button onClick={() => navigate("/CRMTrainingDocs")} color="secondary">
            Back to List
          </Button>
          <Button onClick={handleSubmit} color="primary" disabled={isAdding}>
            {isAdding ? "Saving..." : "Save Training Doc"}
          </Button>
        </div>
      </Form>
    </div>
  );
}
